import { useState } from "react";
import { FiCopy } from "react-icons/fi";
import { capitalizeFirstLetter } from "../utils/Functions";
import { formatPhoneNumber } from "../utils/Functions";
import moment from "moment";

const PartnerDetails = ({ user, page }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (user?.referralCode) {
      navigator.clipboard.writeText(user.referralCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  console.log("partner details", user);

  return (
    <div className="p-6">
      {/* Row 1: General Information || Address Details */}
      <div className="grid grid-cols-2 gap-6 mb-6">
        {/* General Information */}
        <div>
          <h3 className="text-[14px] font-poppins font-semibold text-gray-800 mb-4">
            General Information
          </h3>
          <div className="bg-[#F6F8FC] shadow-sm rounded-[2px] p-4 space-y-3">
            <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
              <span className="text-gray-600 font-poppins">Name</span>
              <span className="text-[#787998] font-poppins">
                : {capitalizeFirstLetter(user?.basicInfo?.name)}
              </span>
            </div>
            {user?.providerType === "individual" ? (
              <>
                <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                  <span className="text-gray-600 font-poppins">DOB</span>
                  <span className="text-[#787998] font-poppins">
                    :{" "}
                    {moment(user?.basicInfo?.dob).format("DD-MM-YYYY") || "N/A"}
                  </span>
                </div>
                <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                  <span className="text-gray-600 font-poppins">Email</span>
                  <span className="text-[#787998] font-poppins">
                    : {user?.basicInfo?.email || "N/A"}
                  </span>
                </div>
              </>
            ) : (
              <>
                {" "}
                <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                  <span className="text-gray-600 font-poppins">Slogan</span>
                  <span className="text-[#787998] font-poppins">
                    : {user?.basicInfo?.slogan || "N/A"}
                  </span>
                </div>
                <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                  <span className="text-gray-600 font-poppins">
                    No of Patients
                  </span>
                  <span className="text-[#787998] font-poppins">
                    : {user?.basicInfo?.patientCount || "N/A"}
                  </span>
                </div>
              </>
            )}
            <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
              <span className="text-gray-600 font-poppins">Referral code</span>
              <span className="text-[#787998] font-medium font-poppins flex items-center gap-2">
                : {user?.referralCode || "N/A"}
                {user?.referralCode && (
                  <>
                    <button
                      onClick={handleCopy}
                      className="text-gray-500 hover:text-indigo-600 transition-colors"
                      title="Copy referral code"
                    >
                      <FiCopy size={12} />
                    </button>
                    {copied && (
                      <span className="text-[10px] text-green-600">
                        Copied!
                      </span>
                    )}
                  </>
                )}
              </span>
            </div>
          </div>
        </div>

        {/* Address Details */}
        <div>
          <h3 className="text-[14px] font-poppins font-semibold text-gray-800 mb-4">
            Address Details
          </h3>
          <div className="bg-[#F6F8FC] shadow-sm rounded-[2px] p-4 space-y-3">
            <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
              <span className="text-gray-600 font-poppins">Address Line 1</span>
              <span className="text-[#787998] font-poppins">
                : {user?.addressInfo?.address1 || "N/A"}
              </span>
            </div>
            <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
              <span className="text-gray-600 font-poppins">Address Line 2</span>
              <span className="text-[#787998] font-poppins">
                : {user?.addressInfo?.address2 || "N/A"}
              </span>
            </div>
            <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
              <span className="text-gray-600 font-poppins">City</span>
              <span className="text-[#787998] font-poppins">
                : {capitalizeFirstLetter(user?.addressInfo?.city) || "N/A"}
              </span>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="grid grid-cols-[60px_1fr] gap-2 text-[12px]">
                <span className="text-gray-600 font-poppins">State</span>
                <span className="text-[#787998] font-poppins ml-[60px]">
                  : {capitalizeFirstLetter(user?.addressInfo?.state) || "N/A"}
                </span>
              </div>
              <div className="grid grid-cols-[60px_1fr] gap-2 text-[12px]">
                <span className="text-gray-600 font-poppins">Pin code</span>
                <span className="text-[#787998] font-poppins">
                  : {user?.addressInfo?.pincode || "N/A"}
                </span>
              </div>
              {page === "admin" && (
                <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px] col-span-2">
                  <span className="text-gray-600 font-poppins">Service Radius</span>
                  <span className="text-[#787998] font-poppins">
                    : {user?.addressInfo?.serviceRadius != null
                      ? `${user.addressInfo.serviceRadius} km`
                      : "N/A"}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Row 2: Contact Person Info || Contact Person Info 2 */}
      {user?.providerType !== "individual" && (
        <div className="grid grid-cols-2 gap-6 ">
          {/* Primary Contact */}
          <div>
            <h3 className="text-[14px] font-poppins font-semibold text-gray-800 mb-4">
              Contact Person Information
            </h3>
            <div className="bg-[#F6F8FC] shadow-sm rounded-[2px] p-4 space-y-3">
              <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                <span className="text-gray-600 font-poppins">
                  Primary Contact
                </span>
                <span className="text-[#787998] font-poppins">
                  : {user?.contactInfo?.[0]?.name || "N/A"}
                </span>
              </div>
              <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                <span className="text-gray-600 font-poppins">Phone Number</span>
                <span className="text-[#787998] font-poppins">
                  : {formatPhoneNumber(user?.contactInfo?.[0]?.phone) || "N/A"}
                </span>
              </div>
              <div className="grid grid-cols-[120px_1fr] gap-2 text-[12px]">
                <span className="text-gray-600 font-poppins">Email ID</span>
                <span className="text-[#787998] font-poppins">
                  : {user?.contactInfo?.[0]?.email || "N/A"}
                </span>
              </div>
            </div>
          </div>

          {/* Secondary Contact */}
          <div>
            <h3 className="text-[14px] font-poppins font-semibold text-gray-800 mb-4">
              Contact Person Information
            </h3>
            <div className="bg-[#F6F8FC] shadow-sm rounded-[2px] p-4 space-y-3">
              <div className="grid grid-cols-[130px_1fr] gap-2 text-[12px]">
                <span className="text-gray-600 font-poppins">
                  Secondary Contact
                </span>
                <span className="text-[#787998] font-poppins">
                  : {user?.contactInfo?.[1]?.name || "N/A"}
                </span>
              </div>
              <div className="grid grid-cols-[130px_1fr] gap-2 text-[12px]">
                <span className="text-gray-600 font-poppins">Phone Number</span>
                <span className="text-[#787998] font-poppins">
                  : {formatPhoneNumber(user?.contactInfo?.[1]?.phone) || "N/A"}
                </span>
              </div>
              <div className="grid grid-cols-[130px_1fr] gap-2 text-[12px]">
                <span className="text-gray-600 font-poppins">Email ID</span>
                <span className="text-[#787998] font-poppins">
                  : {user?.contactInfo?.[1]?.email || "N/A"}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PartnerDetails;
